import createEnum from 'lib/createEnum';

export const APP_INITIALIZED = 'app/APP_INITIALIZED';
export const AUTHENTICATION_SUCCESS = 'app/AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_ERROR = 'app/AUTHENTICATION_ERROR';
export const CONNECTED = 'app/CONNECTED';
export const DISCONNECTED = 'app/DISCONNECTED';
export const SERVER_ERROR = 'app/SERVER_ERROR';
export const PROACTIVE_TRIGGERED = 'app/PROACTIVE_TRIGGERED';

export const serverErrors = createEnum('IDENTITY_TOKEN_TIMEOUT', 'IDENTITY_TOKEN_ERROR');
